import React from 'react';
import Portal from '../components/Portal';
import '../styles/Home.css';

const Home = () => {
  const portals = [
    {
      title: 'Universo Extendido',
      description: 'La historia no puede ser contenida solo en las páginas. Se expande más allá.',
      url: 'https://extendido.grmeneghetti.com.ar/',
      mobileTitle: 'Universo Extendido'
    },
    {
      title: 'Soundtrack',
      description: 'La historia no solo se lee… también se escucha.',
      url: 'https://www.grmeneghetti.com.ar/soundtrack-oficial',
      mobileTitle: 'Música de la Saga'
    },
    {
      title: 'Chronnos Maledictum',
      description: 'Un artefacto que solo obedece al destino.',
      url: 'https://chronnos.grmeneghetti.com.ar/',
      mobileTitle: 'Chronnos Maledictum'
    }
  ];

  return (
    <div className="universe-container">
      <div className="background-overlay"></div>

      <div className="content-wrapper">
        <header className="universe-header">
          <h1 className="universe-title">UNIVERSO</h1>
          <h2 className="universe-subtitle">El Último Redentor</h2>
        </header>

        <div className="portals-container">
          {portals.map((portal, index) => (
            <Portal key={index} {...portal} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;
